import { Skeleton } from "antd";
import styled from "styled-components";

export const StyledLabel = styled.label`
  padding-bottom: 5px;
  height: 30px;
`;
StyledLabel.displayName = "StyledLabel";

export const StyledSkeletonLabel = styled(Skeleton.Input)`
  & .ant-skeleton-input.ant-skeleton-input {
    height: 16px;
    margin-bottom: 3px;
    margin-top: 5px;
    display: block;
  }
`;
StyledSkeletonLabel.displayName = "StyledSkeletonLabel";

export const StyledSkeletonInput = styled(Skeleton.Input)`
  && {
    width: 100%;
    && > .ant-skeleton-input {
      width: 100%;
    }
  }
`;
StyledSkeletonInput.displayName = "StyledSkeletonInput";
